import React from "react";

import theme from "theme";

import Box from "components/Box";
import StyledTable, { IHeader as ITableHeader } from "components/StyledTable";

import { ITableData } from "entities/AssetManagement/components/Table/utils";
import { AMResolution } from "entities/AssetManagement/constants";
import { IAssetManagementCategory } from "entities/AssetManagement/sdk";

interface IProps {
  selectedTab: IAssetManagementCategory;
  resolution: AMResolution;
  headers: ITableHeader<{
    label: string;
    itemCode: string;
    isTotalRow: boolean;
  }>[];
  mappedTableData: Array<ITableData>;
  isLoading?: boolean;
}

const AssetManagementTable = ({
  selectedTab,
  resolution,
  isLoading,
  headers,
  mappedTableData,
}: IProps) => (
  <Box sx={{ marginTop: theme.spacing(3) }}>
    <StyledTable
      key={`${selectedTab.name}-${resolution}`}
      data={mappedTableData}
      headers={headers}
      showLoading={isLoading}
      tableDataTestid="am-table"
    />
  </Box>
);

export default React.memo(AssetManagementTable);
